import EditIcon from "@mui/icons-material/Edit";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FileCopyOutlinedIcon from "@mui/icons-material/FileCopyOutlined";
import PauseCircleOutlineIcon from "@mui/icons-material/PauseCircleOutline";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import StarIcon from "@mui/icons-material/Star";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Chip,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  FormControlLabel,
  ListItem,
  ListItemText,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import React, { useRef, useState } from "react";
import utils from "../../../utils";
import ShowComplements from "./ShowComplements";
import AuthService from "../../../AuthService";
import SearchIcon from "@mui/icons-material/Search";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const DialogSearchProducts = ({
  openBusca,
  escolhaBusca,
  produtosBuscados,
  setSubProdutosBuscados,
  subProdutosBuscados,
  handleOpenBusca,
  setOpenCadProd,
  setProdutoEdit,
  setEscolhaBusca,
  setProdutosBuscados,
  handlePauseProduto,
  duplicarProduto,
}) => {
  const service = new AuthService();
  const input = useRef();
  const [loading, setLoading] = useState(false);

  const verificaBuscaInexistente = () => {
    if (loading) {
      return (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          minHeight="200px"
        >
          <CircularProgress />
        </Box>
      );
    }

    const isInicial = produtosBuscados === null;

    return (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
        minHeight="200px"
      >
        {isInicial ? (
          <>
            <SearchIcon color="action" sx={{ fontSize: 40, mb: 1 }} />
            <Typography>Clique em buscar para pesquisar</Typography>
          </>
        ) : (
          <>
            <ErrorOutlineIcon color="error" sx={{ fontSize: 40, mb: 1 }} />
            <Typography color="error">
              Não encontramos nenhum produto
            </Typography>
          </>
        )}
      </Box>
    );
  };

  const keyDown = (e) => {
    if (e === "click" || e.key === "Enter") {
      setLoading(true);
      const valor = input.current.children[1].children[0].value;
      escolhaBusca === "SUBITEM" ? getSubItens(valor) : getProdutos(valor);
    }
  };
  const handleChangeEscolhaTipoBusca = (event) => {
    setEscolhaBusca(event.target.value);
  };

  const getProdutos = (valorBusca) => {
    setProdutosBuscados([]);
    setSubProdutosBuscados(false);

    const service = new AuthService();
    service
      .get(`/produto/list?q=${valorBusca}&ativo=true`)
      .then((resp) => {
        setProdutosBuscados(resp);
      })
      .catch(console.error)
      .finally(() => {
        setLoading(false);
      });
  };

  const getSubItens = (valorBusca) => {
    const service = new AuthService();
    setProdutosBuscados([]);
    setSubProdutosBuscados(true);

    service
      .get(`/produto/buscar?q=${valorBusca}`)
      .then((resp) => {
        resp.forEach((produto) => {
          produto.complementos = produto.complementos.filter(
            (ele, ind, self) =>
              ind ===
              self.findIndex(
                (elem) => elem.jobid === ele.jobid && elem.id === ele.id
              )
          );
          produto.complementos.forEach((complemento) => {
            complemento.complementoItens = complemento.complementoItens.filter(
              (item) =>
                item.descricao?.toUpperCase().includes(valorBusca.toUpperCase())
            );
          });
        });

        setProdutosBuscados(resp);
      })
      .catch(console.error)
      .finally(() => {
        setLoading(false);
      });
  };

  const isAdmin = service.isAdmin();

  return (
    <Dialog maxWidth="md" fullWidth open={openBusca} onClose={handleOpenBusca}>
      <DialogTitle>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <TextField
            ref={input}
            variant="outlined"
            fullWidth
            style={{ minWidth: "200px" }}
            label={"Nome ou código"}
            name="pesquisa"
            onKeyPress={(a) => keyDown(a)}
          />
          <Box pl={2}>
            <Button
              variant="contained"
              sx={{ height: "3.5rem", width: "8rem" }}
              color="primary"
              disabled={loading}
              onClick={() => keyDown("click")}
            >
              {loading ? "Buscando..." : "Buscar"}
            </Button>
          </Box>
        </Box>
      </DialogTitle>
      <DialogContent>
        <FormControl>
          <RadioGroup row>
            <FormControlLabel
              control={
                <Radio
                  onChange={handleChangeEscolhaTipoBusca}
                  checked={escolhaBusca === "PRODUTO"}
                  value="PRODUTO"
                />
              }
              label="Buscar produtos"
            />
          </RadioGroup>
        </FormControl>
        <FormControlLabel
          control={
            <Radio
              onChange={handleChangeEscolhaTipoBusca}
              checked={escolhaBusca === "SUBITEM"}
              value="SUBITEM"
            />
          }
          label="Buscar subitens"
        />

        {produtosBuscados
          ? produtosBuscados.length > 0
            ? produtosBuscados.map((produto) => (
                <React.Fragment key={produto.id}>
                  <Accordion square="true">
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <ListItem>
                        <ListItemText
                          primary={
                            <React.Fragment>
                              <Typography
                                color="textSecondary"
                                variant="caption"
                              >
                                {produto?.grupoProduto?.ativo ? (
                                  produto?.grupoProduto?.descricao?.toUpperCase()
                                ) : (
                                  <Typography color="error" variant="caption">
                                    {produto?.grupoProduto?.descricao?.toUpperCase()}{" "}
                                    (inativo)
                                  </Typography>
                                )}
                              </Typography>
                              <Typography
                                color="primary"
                                style={{
                                  fontWeight: "400",
                                  fontFamily: "Bebas Neue",
                                  textTransform: "capitalize",
                                  fontSize: "135%",
                                }}
                              >
                                {produto.nome}
                                {produto.promocaoAtiva ? (
                                  <Chip
                                    color="primary"
                                    size="small"
                                    label="promo"
                                    icon={<StarIcon />}
                                    style={{ marginLeft: "15px" }}
                                  />
                                ) : null}
                              </Typography>
                            </React.Fragment>
                          }
                        />

                        <Typography>
                          {utils.formatNumber(produto.preco)}
                        </Typography>

                        <Button
                          disabled={!produto?.grupoProduto?.ativo}
                          edge="end"
                          color={produto.pausado ? "secondary" : "primary"}
                          onClick={(event) => {
                            handlePauseProduto(event, produto);
                            event.stopPropagation();
                          }}
                        >
                          {produto.pausado ? (
                            <PlayCircleOutlineIcon />
                          ) : (
                            <PauseCircleOutlineIcon />
                          )}
                        </Button>

                        <Button
                          title="Editar produto"
                          disabled={!produto?.grupoProduto?.ativo}
                          onClick={(event) => {
                            setProdutoEdit(produto);
                            setOpenCadProd(true);
                            event.stopPropagation();
                          }}
                        >
                          <EditIcon style={{ width: "20px" }} />
                        </Button>
                        {produto?.grupoProduto?.id !== -1 && isAdmin ? (
                          <Button
                            title="Criar uma cópia deste produto"
                            onClick={(event) => {
                              duplicarProduto(produto);
                              event.stopPropagation();
                            }}
                          >
                            <FileCopyOutlinedIcon style={{ width: "20px" }} />
                          </Button>
                        ) : null}
                      </ListItem>
                    </AccordionSummary>

                    {subProdutosBuscados && (
                      <AccordionDetails>
                        <ShowComplements
                          produto={produto}
                          produtosBuscados={produtosBuscados}
                          saveProdutosBuscados={setProdutosBuscados}
                        />
                      </AccordionDetails>
                    )}

                    <Divider />
                  </Accordion>
                </React.Fragment>
              ))
            : verificaBuscaInexistente()
          : verificaBuscaInexistente()}
      </DialogContent>
    </Dialog>
  );
};

export default DialogSearchProducts;
